import { createRoute, useNavigate } from "@tanstack/react-router";
import { AppShell } from "@/components/ui/app-shell";
import { HomePage, ScriptsShell } from "@/features/scripts";
import { rootRoute } from "./root";

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: function Home() {
    const navigate = useNavigate();
    return (
      <AppShell>
        <ScriptsShell>
          <HomePage
            onOpenScript={scriptId => navigate({ to: "/scripts/$scriptId", params: { scriptId } })}
          />
        </ScriptsShell>
      </AppShell>
    );
  },
});
